<template>
  <div v-loading="loading">
    <el-row
      type="flex"
      justify="space-between"
      :gutter="30"
    >
      <el-col :span="8">
        <LevelCalibrationTable
          :result="result"
        ></LevelCalibrationTable>
      </el-col>
      <el-col :span="16">
        <LevelCalibrationGraph
          :result="result"
        ></LevelCalibrationGraph>
      </el-col>
    </el-row>
  </div>

</template>

<script>

import requestSender from "@/api/base/requestSender";
import LevelCalibrationTable from "@/componentsCompany/level/calibration/LevelCalibrationTable.vue";
import LevelCalibrationGraph from "@/componentsCompany/level/calibration/LevelCalibrationGraph.vue";

export default {
  name: "LevelCalibrationBlock",
  components: { LevelCalibrationGraph, LevelCalibrationTable },
  props: {
    filters: {type: Object, required: true},
  },
  computed: {},
  mounted() {
    this.loadResults();
  },
  data() {
    return {
      loading: false,
      result: [],
    }
  },
  methods: {
    loadResults(){
      this.loading = true;

      requestSender('post', 'calibration/get-calibration-result', {
        ...this.filters,
      })
        .then(data => {
          this.result = data.result;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>


<style lang="scss">

</style>